import { fetchWithAuth } from '../helpers';

const getAllTemplates = async () => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/question-templates/`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const getTemplateByType = async (questionTypeId: number) => {
  const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/question-templates/${questionTypeId}`, {
    method: 'GET',
    headers: { "ngrok-skip-browser-warning": "69420" },
  });
  return handleResponse(response);
};

const upsertTemplate = (questionTypeId: number, templateJson: any) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/question-templates/${questionTypeId}`, {
    method: 'PUT',
    headers: { 
      'Content-Type': 'application/json',
      "ngrok-skip-browser-warning": "69420" 
    },
    body: JSON.stringify({ template_json: templateJson })
  })
    .then(handleResponse);
};

const deleteUserTemplate = (questionTypeId: number) => {
  return fetchWithAuth(`${process.env.REACT_APP_API_URL}/api/question-templates/${questionTypeId}`, {
    method: 'DELETE',
    headers: { "ngrok-skip-browser-warning": "69420" }
  })
    .then(handleResponse);
};

function handleResponse(response: Response) {
  return response.text().then((text: string) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}

export const questionTemplateService = {
  getAllTemplates,
  getTemplateByType,
  upsertTemplate,
  deleteUserTemplate
};
